const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'agent', label: 'Agent', sortable: false, thStyle: 'width: 30%' },
    { key: 'path', label: 'Path', sortable: false },
    { key: 'created_at', label: 'Detect Time', sortable: false, thStyle : 'width: 20%' },
    // { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  },
  ],
  KO : [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'agent', label: '에이전트', sortable: false, thStyle: 'width: 30%' },
    { key: 'path', label: '경로', sortable: false },
    { key: 'created_at', label: '탐지시각', sortable: false, thStyle : 'width: 20%' },
    // { key: 'func', label: '더 보기', sortable: false, thStyle: 'width: 10%'  },
  ],
  JP: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'agent', label: 'エージョント', sortable: false, thStyle: 'width: 30%' },
    { key: 'path', label: 'パス', sortable: false },
    { key: 'created_at', label: '検出時間', sortable: false, thStyle : 'width: 20%' },
    // { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  },
  ]
}

const fields = { i18n_fields }

export default fields